const api = "https://hub.thesaunaheater.com/api/contact-request";
const quoteForm = document.getElementById("cartForm");
const FORM_DATA_KEY = "contactFormData";
const FORM_SENT_KEY = "contactFormSent";

const wrapper = document.querySelector(".cart-wrapper");

if (localStorage.getItem(FORM_SENT_KEY) === "true") {
  wrapper.dataset.state = "sent";
}
// 🟡 Restore form data if available
const savedData = localStorage.getItem(FORM_DATA_KEY);
if (savedData) {
  const parsed = JSON.parse(savedData);
  for (const [key, value] of Object.entries(parsed)) {
    const field = quoteForm.elements.namedItem(key);
    if (field) field.value = value;

  }
}

const phoneInput = document.querySelector("#phone");

const iti = window.intlTelInput(phoneInput, {
  initialCountry: "auto",
  geoIpLookup: (callback) => {
    fetch("https://ipapi.co/json")
      .then((res) => res.json())
      .then((data) => callback(data.country_code))
      .catch(() => callback("us"));
  },
  formatOnDisplay: true,
  utilsScript:
    "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
});

quoteForm.addEventListener("change", () => {
  const quoteData = new FormData(quoteForm);
  const data = Object.fromEntries(quoteData.entries());

  const phoneInput = quoteForm.elements.namedItem("phone");
  if (iti && phoneInput?.value.trim()) {
    data.phone = iti.getNumber(intlTelInputUtils.numberFormat.E164); //
  }

  localStorage.setItem(FORM_DATA_KEY, JSON.stringify(data));
  console.log(data)
});

phoneInput.addEventListener("blur", () => {
  if (phoneInput.value.trim()) {
    if (!iti.isValidNumber()) {
      phoneInput.classList.add("invalid-input");
    } else {
      phoneInput.classList.remove("invalid-input");
    }
  }
});

quoteForm.addEventListener("submit", async (e) => {
  e.preventDefault();

  const rawData = localStorage.getItem(FORM_DATA_KEY);
  const data =  await JSON.parse(rawData);
  const message = `Address: ${data?.streetAddress}
City: ${data?.city}, ZIP: ${data?.postalCode}
Country: ${data?.country}

Preferred Language: ${data?.language}

Message: ${data.message}`;
  const jsonData = JSON.stringify({
    ...data,
    name: data?.firstName + " " + data?.lastName,
    message,
    shop: window.Shopify.shop,
  });

  const res = await fetch(api, {
    method: "POST",
    body: jsonData,
  });

  if (res.ok) {
    wrapper.dataset.state = "sent";
    localStorage.setItem(FORM_SENT_KEY, "true");
  }
});
